/**
Author - Venkatesh Pullaganti😃
Git - https://github.com/venkatesh1146
**/

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {ActionButton} from 'screens/commons';
import {KYC_FLOWS} from 'constants/FlowConstants';

const propTypes = {
  statusMessage: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
  }),
  errorMessage: PropTypes.string,
  onUpload: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  showRetryOption: PropTypes.bool.isRequired,
  flow: PropTypes.string,
};

const FailureView = ({
  statusMessage,
  errorMessage,
  onUpload,
  onRetry,
  isLoading,
  showRetryOption,
  flow,
}) => {
  const isAllFi = flow === KYC_FLOWS.ALL_FI;
  return (
    <FailureContainer>
      <FailureTitle>{statusMessage?.title || 'Verification Not Completed'}</FailureTitle>
      <FailureDescription>
        {statusMessage?.description ||
          (isAllFi
            ? 'Please try connecting your account again.'
            : 'Please upload income declaration to continue.')}
      </FailureDescription>
      {errorMessage && <ErrorMessage>Reason: {errorMessage}</ErrorMessage>}
      {!isAllFi && (
        <StyledActionButton
          buttonText="Upload Income Declaration"
          callback={onUpload}
          isLoading={isLoading}
          isDisabled={isLoading}
        />
      )}
      {showRetryOption && (
        <SecondaryButton onClick={onRetry} disabled={isLoading}>
          {isAllFi ? 'Try Again' : 'Try Again with OTP'}
        </SecondaryButton>
      )}
    </FailureContainer>
  );
};

const FailureContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  padding: 2rem;
  background: #fef2f2;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
`;

const FailureTitle = styled.h2`
  color: #dc2626;
  font-weight: 600;
  font-size: 1.25rem;
  text-align: center;
  margin-bottom: 1rem;
`;

const FailureDescription = styled.p`
  color: #4b5563;
  text-align: center;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const ErrorMessage = styled.p`
  color: #dc2626;
  font-size: 0.875rem;
  text-align: center;
  margin: 1rem 0;
  padding: 0.75rem;
  background: #fee2e2;
  border-radius: 6px;
  width: 100%;
`;

const StyledActionButton = styled(ActionButton)`
  width: 100%;
  max-width: 600px;
  margin-top: 2rem;
`;

const SecondaryButton = styled.button`
  margin-top: 1rem;
  padding: 0.75rem 1.5rem;
  background: transparent;
  border: 2px solid #9333ea;
  border-radius: 8px;
  color: #9333ea;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  width: 100%;
  max-width: 600px;

  &:hover:not(:disabled) {
    background: #f5f3ff;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

FailureView.propTypes = propTypes;

export default FailureView;
